<template>
    <div class="content-wrapper">
        <!-- Content Header (Page header) -->
        <div class="content-header">
            <div class="container-fluid">
                <div class="row mb-2">
                    <div class="col-sm-6">
                        <h1 class="m-0 text-dark">Final Collection Receive</h1>
                    </div><!-- /.col --> 
                </div><!-- /.row --> 
            </div><!-- /.container-fluid -->
        </div>
        <!-- /.content-header -->
        <!-- Main content -->
        <section class="content">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12">
                        <div class="card">
                            <div class="card-header">
                                <div class="row">
                                    <div class="col-md-2">
                                        <div class="form-group">                                            
                                            <label for="deposit_id">Deposit ID </label>
                                            <input type="text" id="deposit_id" v-model="search.deposit_id" placeholder="Deposit ID like 200-210" class="form-control">
                                        </div>
                                    </div>
                                    <div class="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-xs-12" v-if="authUser.role_id != 7">
                                        <div class="form-group">
                                            <label for="title">{{ $t('globalTrans.hub') }} <span class="text-danger" title="Required">*</span></label>
                                            <v-select name="hub_id"
                                                multiple
                                                v-model="search.hub_id"
                                                label="text"
                                                :reduce="item => item.id"
                                                :options= hubList
                                                :placeholder="$t('globalTrans.select')"
                                            />
                                        </div>
                                    </div>
                                    <div class="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-xs-12">
                                        <div class="form-group">
                                            <label for="start_date">Start Date</label>
                                            <input type="date" id="start_date" v-model="search.start_date" class="form-control" />
                                        </div> 
                                    </div>
                                    <div class="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-xs-12">
                                        <div class="form-group">
                                            <label for="end_date">End Date</label>
                                            <input type="date" id="end_date" v-model="search.end_date" class="form-control" />
                                        </div> 
                                    </div>
                                    <div class="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-xs-12">
                                        <div class="form-group">
                                            <label for="status">Status</label>
                                            <v-select name="status"
                                                multiple
                                                v-model="search.status"
                                                label="text"
                                                :reduce="item => item.id"
                                                :options= statusList
                                                :placeholder="$t('globalTrans.select')"
                                            />
                                        </div>
                                    </div>
                                     <div class="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-xs-12">
                                        <div class="form-group">
                                            <label for="rider_id">Rider</label>
                                            <v-select name="reason_id"
                                                v-model="search.rider_id"
                                                label="text"
                                                :reduce="item => item.id"
                                                :options= riderList
                                                :placeholder="$t('globalTrans.select')"
                                            />
                                        </div>
                                    </div>
                                     <div :class="merchantColumn">
                                        <div class="form-group">
                                            <label for="rider_id">Merchant</label>
                                            <v-select name="merchant_id"
                                                multiple
                                                v-model="search.merchant_id"
                                                label="text"
                                                :reduce="item => item.id"
                                                :options= merchantList
                                                :placeholder="$t('globalTrans.select')"
                                            />
                                        </div>
                                    </div>
                                     <div class="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-xs-12">
                                        <div class="form-group">
                                            <button class="btn btn-info btn-sm" type="submit" @click.prevent="searchData" style="margin-top:28px;"><i class="fa fa-search"></i></button>
                                            <button class="btn btn-warning btn-sm ml-2" @click.prevent="reload" style="margin-top:28px;"><i class="fa fa-sync-alt"></i></button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body">
                                <b-overlay :show="loader">
                                    <div class="table-responsive">
                                        <table id="collectionTable" class="table table-bordered table-striped table-sm">
                                            <thead>
                                                <tr>
                                                    <td colspan="3">
                                                        <label>
                                                            <input type="checkbox" @click="selectAll" v-model="allSelected">
                                                            <p style="display: inline-block; margin-left: 4px; font-size: 15px;">Select All</p>
                                                        </label>
                                                    </td>
                                                    <td colspan="2">
                                                        <label><p>Deposited Order Amount : {{ this.finalCollectableAmount }}</p></label>
                                                    </td>
                                                    <td colspan="2">
                                                        <label><p>Total Selected Order : {{ this.totalSelectedOrder }}</p></label>
                                                    </td>
                                                    <td colspan="2">
                                                        <label><p>Selected Order Amount : {{ this.totalSelectedAmount }}</p></label>
                                                        <button class="btn btn-success float-right btn-sm mr-2" @click="receive"> Receive</button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>Order ID</th>
                                                    <th>Merchant</th>
                                                    <th>Rider</th>
                                                    <th>Destination Hub</th>
                                                    <th>Date</th>
                                                    <th>Price</th>
                                                    <th>Collected</th>
                                                    <th>Merchant Amount</th>
                                                    <th>Status</th>
                                                </tr>
                                            </thead>
                                            <tfoot>
                                                <tr>
                                                    <th>Order ID</th>
                                                    <th>Merchant</th>
                                                    <th>Rider</th>
                                                    <th>Destination Hub</th>
                                                    <th>Date</th>
                                                    <th>Price</th>
                                                    <th>Collected</th>
                                                    <th>Merchant Amount</th>
                                                    <th>Status</th>
                                                </tr>
                                            </tfoot>
                                            <tbody>
                                                <tr v-for="(item, index) in listData" :key="index">
                                                    <td class="order-id">
                                                        <label>
                                                            <input v-model="form.orderIds" @click="select(item.id)" :value="item.id" type="checkbox" class="order-checkbox" />
                                                            <p>{{ item.id }}</p>
                                                        </label>
                                                    </td>
                                                    <td @click="orderLog(item.logs)">{{  item.merchant ? item.merchant.business : '' }}</td>
                                                    <td>{{ item.rider ? item.rider.name : '' }}</td>
                                                    <td>{{ item.destination ? item.destination.name : '' }}</td>
                                                    <td>{{ item.date }}</td>
                                                    <td>{{ item.price }}</td>
                                                    <td>{{ item.collected }}</td>
                                                    <td>{{ item.amount }}</td>
                                                    <td><span class="label p-1" :class="'status-'+item.status">{{ getStatus(item.status) }}</span></td>
                                                </tr>
                                                <infineLoading v-if="spinner" @distance="1" @infinite="loadFinalReceivableData"></infineLoading>
                                            </tbody>
                                        </table>
                                    </div>
                                </b-overlay>
                            </div>
                        </div>
                    </div>
                </div>
            </div><!-- /.container-fluid -->
        </section>
        <!-- /.content -->
        <div v-if="orderLogModal" class="modal fade show" style="display:block" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header bg-info text-white">
                        <h5 class="modal-title text-center w-100">Order Log</h5>
                        <button type="button" class="close" aria-label="Close" @click="cancelModal">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <table class="table table-bordered table-sm">
                            <tr>
                                <th>Action By</th>
                                <th>Action</th>
                                <th>Date & Time</th>
                            </tr>
                            <tr v-for="(log, index) in order_logs" :key="index">
                                <td>{{ log.operation_by }}</td>
                                <td>{{ log.operation }}</td>
                                <td>{{ log.created_at | dateformat }} at {{ log.created_at | timeformat }}</td>
                            </tr>
                        </table>                      
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-sm btn-danger" @click="cancelModal">Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import config from '@/config'
    import infineLoading from 'vue-infinite-loading'
    import moment from 'moment'
    export default {
        name:'Collection',
        components: {
            infineLoading: infineLoading,
        },
        data(){
            return {   
                orderLogModal:false,
                order_logs:[],
                loader: true,             
                loading: false,  
                spinner: true,  
                merchantList: [],         
                listData: [],
                statusList: [
                    { text: 'Delivered', id: 14 },
                    { text: 'Partial Delivered', id: 15 },
                    { text: 'Damage/Lost', id: 16 },
                    { text: 'Exchanged', id: 19 },
                    { text: 'Cancel', id: 20 }
                ],
                search: {
                    rider_id: '',
                    merchant_id: '',
                    deposit_id: '',
                    hub_id: '',
                    start_date: moment().format('YYYY-MM-DD'),
                    end_date: moment().format('YYYY-MM-DD'),
                    status: []
                },
                form:{
                    rider_id : '',
                    date : '',
                    orderIds: []
                },
                errors:[],
                page: 1,
                key:'',
                allSelected: false,
                totalSelectedOrder: 0,
                totalSelectedAmount: 0,
                finalCollectableAmount: 0,
                totalOrder: 0,
                merchantColumn: 'col-xl-2 col-lg-2 col-md-2 col-sm-6 col-xs-12'
            }
        },
        created(){
            this.loadFinalReceivableData();
            this.loadFinalReceivableMerchant();
            this.loadFinalReceivableSummary();
        },
        computed : {
            riderList: function () {
                if (this.authUser.role_id == 7) {
                    return this.$store.state.commonObj.riderList.filter(el => el.hub_id === this.authUser.hub_id)
                }
                return this.$store.state.commonObj.riderList
            },
            hubList () {
                return this.$store.state.commonObj.hubList
            },
            authUser () {
                return this.$store.state.authUser
            }
        },
        methods:{
            selectAll () {
                this.loader = true
                this.form.orderIds = [];
                if (!this.allSelected) {
                    this.totalSelectedOrder = this.totalSelectedAmount = 0
                    const orders = this.listData
                    for (var order in orders) {
                        this.totalSelectedAmount += parseFloat(orders[order].collected)
                        this.form.orderIds.push(orders[order].id);
                    }
                    this.totalSelectedOrder = this.form.orderIds.length
                } else {
                    this.totalSelectedOrder = 0
                    this.totalSelectedAmount = 0
                }
                this.loader = false
            },
            select(orderId) {
                const orders = this.listData
                const tmpOrder = orders.find(order => order.id == orderId)

                if (!this.form.orderIds.includes(orderId)) {
                    this.form.orderIds.push(orderId)
                    this.totalSelectedAmount += parseFloat(tmpOrder.collected)
                } else {
                    this.form.orderIds.splice(this.form.orderIds.indexOf(orderId), 1)
                    this.totalSelectedAmount -= parseFloat(tmpOrder.collected)
                } 
                this.totalSelectedOrder = this.form.orderIds.length
                this.allSelected = false;                  
            },
            async receive () {
                this.loader = true
                if (this.authUser.role_id == 7 ){
                    this.form = Object.assign(this.form, { date: this.search.date, rider_id: this.search.rider_id, hub_id: this.authUser.hub_id, collection: this.totalSelectedAmount }) 
                } else {
                    this.form  = Object.assign(this.form, { date: this.search.date, rider_id: this.search.rider_id, hub_id: this.search.hub_id, collection: this.totalSelectedAmount })
                }
                const isValidated = this.checkValidation(this.form)
                if (isValidated) {
                    const response = await config.postData('/accounts/collection/final-receive', this.form)
                    if (response.status == 201) {
                        this.allSelected = false
                        this.totalSelectedOrder = this.totalSelectedAmount = 0
                        this.searchData()
                        this.$toast.success({
                            title: 'Success',
                            message: 'Payment Received',
                            color: '#218838'
                        }) 
                    } else {
                        this.$toast.error({
                            title: 'Error',
                            message: 'Sorry, something went wrong',
                            color: '#dc3545'
                        })
                    }
                }
                this.loader = false
            },
            checkValidation (data) {
                if (data.orderIds.length == 0) {
                    this.$toast.error({
                        title: 'Error',
                        message: 'Please select order',
                        color: '#dc3545'
                    }) 
                    return false
                }
                return true
            },
            searchData () {
                this.totalOrder = this.totalSelectedOrder = 0
                this.listData = []
                this.page = 1
                this.allSelected = false
                this.loadFinalReceivableData()
                this.loadFinalReceivableMerchant()
                this.loadFinalReceivableSummary()
            },
            async loadFinalReceivableData($state){
                this.loader = true
                let vm = this;
                const params = this.authUser.role_id == 7 ? Object.assign({}, this.search, { hub_id: this.authUser.hub_id, page: this.page }) : Object.assign({}, this.search, { page: this.page })
                config.getData('/accounts/collection/final-receivable-list', params)
                 .then(res => {
                    return res
                }).then(response => {
                    if (response.status == 200) {
                        this.totalOrder += response.data.data.length
                        response.data.data.map(item => {
                            vm.listData.push(item)
                        })
                        if (this.totalOrder < response.data.total) {
                            this.loader = true
                            this.spinner = true
                            if ($state) $state.loaded()
                        } else {
                            this.loader = false
                            this.spinner = false
                        }
                    } else {
                        this.loader = false
                        this.spinner = false
                    }
                    // if (!$state) this.loader = false
                });
                this.page = this.page + 1;
            },
            async loadFinalReceivableSummary(){     
                this.loader = true
                const params = this.authUser.role_id == 7 ? Object.assign({}, this.search, { hub_id: this.authUser.hub_id }) : this.search  
                const response = await config.getData('/accounts/collection/final-receivable-summary', params)
                this.loader = false
                if (response.status == 200){
                    this.finalCollectableAmount = response.collected
                } else {
                    this.finalCollectableAmount = 0;
                } 
            },
            async loadFinalReceivableMerchant(){     
                this.loader = true
                const params = this.authUser.role_id == 7 ? Object.assign({}, this.search, { hub_id: this.authUser.hub_id }) : this.search  
                const response = await config.getData('/accounts/collection/final-receivable-merchant-list', params)
                this.loader = false
                if (response.status == 200){
                    this.merchantList = response.merchantList
                    this.search.merchant_id = this.search.merchant_id.length > 0 ? this.search.merchant_id : response.merchantList.map(merchant => merchant.id);
                    this.merchantColumn = response.merchantList.length > 0 ? 'col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12' : 'col-xl-2 col-lg-2 col-md-2 col-sm-6 col-xs-12'
                } else {
                    this.merchantColumn = 'col-xl-2 col-lg-2 col-md-2 col-sm-6 col-xs-12'
                } 
            },
            reload () {
                this.search.status = []
                this.listData = []
                this.page = 1
                this.totalSelectedOrder = 0
                this.finalCollectableAmount = 0;
                this.search.activity_date = this.search.hub_id = this.search.rider_id = this.search.merchant_id = this.search.deposit_id = ''
                this.search.start_date = this.search.end_date = moment().format('YYYY-MM-DD')
                this.merchantColumn = 'col-xl-2 col-lg-2 col-md-2 col-sm-6 col-xs-12'
            },
            cancelModal(){
                this.orderLogModal = false;
                document.body.classList.remove("modal-open");
            },
            getStatus (status) {
                const tmpStatus = this.$store.state.statusList.find(tmp => tmp.id == status)
                return typeof tmpStatus !== 'undefined' ? tmpStatus.text : ''
            },
            orderLog (logs) {
                this.order_logs = logs 
                this.orderLogModal = true
            }
        }
    }
</script>